import Button from '../../../components/CustomButtons/ButtonTS';
import Tune from '@material-ui/icons/Settings';
import React from 'react';
import { INode } from '../../helpers/interfaces';
import Tooltip from "@material-ui/core/Tooltip";

interface IEditIconProps {
	show: boolean;
	node: INode;
	showNodeLevelsCard(node: INode): void;
}

export const NodeLevelsIcon = (props: IEditIconProps) => {
	const { show, showNodeLevelsCard, node } = props;
	if (!show) {
		return null;
	}
	return (
	    <Tooltip title="Change thresholds">
            <div>
                <Button
                    color={'info'}
                    simple
                    justIcon
                    onClick={() => showNodeLevelsCard(node)}
                    data-testid='baseIcon'
                >
                    <Tune />
                </Button>
            </div>
		</Tooltip>
	);
};

export default NodeLevelsIcon;
